export const countryRules = {
  BE: {
    aifmRegex: /^\d{10}$/,
    fundRegex: /^\d{5}-\d{4}$/,
    aifmExample: '0000012345',
    aifExample: '01234-0001',
    country: 'Belgium'
  }, // Belgium
  DK: {
    aifmRegex: /^\d{5}$/,
    fundRegex: /^\d{5}$/,
    aifmExample: '12345',
    aifExample: '12345',
    country: 'Denmark'
  }, // Denmark
  FI: {
    fundRegex: /^\d{7}(-\d{1})?#\d{3}$/,
    aifmRegex: /^\d{7}(-\d{1})?$/,
    aifmExample: '1234567, 1234567-1',
    aifExample: '1234567#001, 1234567-1#001',
    country: 'Finland'
  }, // Finland
  DE: {
    aifmRegex: /^\d{8}$/,
    fundRegex: /^\d{8}$/,
    aifmExample: '12345678',
    aifExample: '12345678',
    country: 'Germany'
  }, // Germany
  IE: {
    aifmRegex: /^[A-Z]\d{6}$/,
    fundRegex: /^[A-Z]\d{6}$/,
    aifmExample: '12345678',
    aifExample: '12345678',
    country: 'Ireland'
  }, // Ireland
  LU: {
    aifmRegex: /^[A-Z]\d{8}$/,
    fundRegex: /^[A-Z]\d{8}[-_]\d{8}$/,
    aifmExample: 'A00001234',
    aifExample: 'O00001234-00000001, O00001234-00000001',
    country: 'Luxemburg'
  }, // Luxemburg
  NL: {
    aifmRegex: /^[A-Z]{3}\d{3}$/,
    fundRegex: /^500\d{5}$/,
    aifmExample: 'BJK123',
    aifExample: '50012345',
    country: 'Netherlands'
  }, // Netherlands
  NO: {
    aifmRegex: /^FT\d{8}$/,
    fundRegex: /^FT\d{8}$/,
    aifmExample: 'FT12345678',
    aifExample: 'FT12345678',
    country: 'Norway'
  }, // Norway
  SE: {
    aifmRegex: /^\d{5}$/,
    fundRegex: /^\d{5}$/,
    aifmExample: '12345',
    aifExample: '12345',
    country: 'Sweden'
  }, // Sweden
  UK: {
    aifmRegex: /^\d{6,7}$/,
    fundRegex: /^\d{6,7}$/,
    aifmExample: '1234567',
    aifExample: '1234567',
    country: 'United Kingdom'
  }, // United Kingdom
  Other: {
    aifmRegex: /^.{1,30}$/,
    fundRegex: /^.{1,30}$/
  }
};
